module.exports = __webpack_public_path__ + "img/pic_recruit.c9d74bde.png";